export class RiferimentoFascicoloCartaceoVO {
    collocazioneFisica: string;
    descrizioneContenuto: string;
}